import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import {withRouter} from "react-router-dom";
import {addCoupon, editCoupon, get_coupons, removeCoupon} from "../actions/coupons";
import LinearProgress from "@mui/material/LinearProgress";
import {Box, Button, Fab, Paper, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from "@mui/icons-material/Add";
import Typography from "@mui/material/Typography";
import CouponDialog from "./Dialogs/CouponDialog";

const styles = {
    paper: {
        margin: 15
    },
    fab: {
        position: 'absolute',
        bottom: "40px",
        right: "20px",
    },
};


class Coupons extends Component {

    constructor(props) {
        super(props);
        this.state = {
            coupon: null,
            coupons: null,
            errors: {},
            openedDialog: null
        }
    }

    componentDidMount() {
        this.refreshCoupons();
    }

    refreshCoupons() {
        get_coupons().then(r => {
            this.setState({
                ...this.state,
                coupons: r.data
            });
        });
    }

    addCouponDialog() {
        this.setState({
            ...this.state,
            openedDialog: "add"
        });
    }

    editCouponDialog(coupon) {
        this.setState({
            ...this.state,
            coupon: coupon,
            openedDialog: "edit"
        });
    }

    removeCouponDialog(coupon) {
        removeCoupon(coupon.id).then(res => {
            this.refreshCoupons();
        });
    }

    closeDialog() {
        this.setState({
            ...this.state,
            openedDialog: null,
            coupon: null
        });
    }

    addCoupon(state) {
        addCoupon(
            state.type,
            state.value,
            state.allowed,
            state.code,
            state.usages,
            state.begin_at,
            state.expiration_at,
            state.active
        ).then(res => {
            this.closeDialog();
            this.refreshCoupons();
        }).catch(err => {
            this.setState({
                ...this.state,
                errors: err.response.data.errors
            });
        });
    }

    editCoupon(state) {
        editCoupon(
            this.state.coupon.id,
            state.type,
            state.value,
            state.allowed,
            state.code,
            state.usages,
            state.begin_at,
            state.expiration_at,
            state.active
        ).then(res => {
            this.closeDialog();
            this.refreshCoupons();
        }).catch(err => {
            this.setState({
                ...this.state,
                errors: err.response.data.errors
            });
        });
    }

    clearErrors() {
        this.setState({
            ...this.state,
            errors: {}
        });
    }

    render() {
        if (this.state.coupons === null) {
            return <LinearProgress/>
        }
        const {classes} = this.props;
        return (<Box className={classes.paper}>
            {this.state.openedDialog === "add" &&
            <CouponDialog clearErrors={this.clearErrors.bind(this)} errors={Object.values(this.state.errors).join(", ")}
                          handleSave={this.addCoupon.bind(this)}
                          handleClose={this.closeDialog.bind(this)}/>}

            {this.state.openedDialog === "edit" &&
            <CouponDialog clearErrors={this.clearErrors.bind(this)} errors={Object.values(this.state.errors).join(", ")}
                          coupon={this.state.coupon}
                          handleSave={this.editCoupon.bind(this)}
                          handleClose={this.closeDialog.bind(this)}/>}

            <Typography variant={"h5"} gutterBottom={true}>Coupons</Typography>
            <Paper>
                <Table>
                    <TableHead>
                        <TableRow>
                            {false && <TableCell align="center">#</TableCell>}
                            <TableCell align="center">Active</TableCell>
                            <TableCell align="center">Code</TableCell>
                            <TableCell align="center">Discount</TableCell>
                            <TableCell align="center">Allowed on</TableCell>
                            <TableCell align="center">Remaining usages</TableCell>
                            <TableCell align="center">Used count</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.coupons.map((coupon) =>
                            <TableRow key={coupon.id}>
                                {false && <TableCell align="center">{coupon.id}</TableCell>}
                                <TableCell align="center">{coupon.active ? "Yes" : "No"}</TableCell>
                                <TableCell align="center">{coupon.code}</TableCell>
                                <TableCell align="center">
                                    {coupon.type === "fixed" ? <>
                                        {coupon.value} EUR
                                    </> : <>
                                        {coupon.value}%
                                    </>}
                                </TableCell>
                                <TableCell align="center">{coupon.allowed}</TableCell>
                                <TableCell align="center">{coupon.usages ? coupon.usages : "Infinite"}</TableCell>
                                <TableCell align="center">
                                    {coupon.premiums.length}
                                </TableCell>
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<EditIcon/>}
                                        onClick={() => {
                                            this.editCouponDialog(coupon);
                                        }}
                                        style={{marginRight: 10}}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<ClearIcon/>}
                                        onClick={() => {
                                            this.removeCouponDialog(coupon);
                                        }}
                                    >
                                        Remove
                                    </Button>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Paper>

            <Fab color="primary" aria-label="add" className={classes.fab}
                 onClick={() => {
                     this.addCouponDialog();
                 }}>
                <AddIcon/>
            </Fab>
        </Box>)
    }
}

const mapStateToProps = state => ({});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {}
)(Coupons)));
